import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'
import { useHeaderStore } from '~/modules/api/stores/header'

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  if (import.meta.client) {
    const headerStore = useHeaderStore()
    if (headerStore.isMobileApp) {
      const authUserIsLogged = await fetchUserIsLogged()
      if (to.path === '/login-app' && authUserIsLogged.logged === true) {
        navigateTo(routes().home(), { external: true })
      } else if (
        to.path !== '/login-app' &&
        authUserIsLogged.logged === false
      ) {
        navigateTo(routes().loginApp(), { external: true })
      }
    }
  }

  return
})
